module.exports = __webpack_public_path__ + "img/0Q3C6212_FoamcoreMatted.0659088b.jpg";